<template>
  <div v-if="showMenuWindow">
    <div class="mask" @click="cancel">
    </div>
    <div class="menuWindow a-ipx-bottom-border">
      <div class="title">
        排序及筛选
      </div>
      <div class="subtitle">
        排序
      </div>
      <div class="optionBlock">
        <div
          v-for="( item, index ) in sortOptionList"
          :key="index"
          class="option"
          :class="isSortOptionActive( index ) ? [ 'active' ] : []"
          @click="selectSortOption( index )">
          {{ item }}
        </div>
      </div>
      <div class="subtitle" v-if="showFilter">
        筛选
      </div>
      <div class="optionBlock" v-if="showFilter">
        <div
          v-for="( item, index ) in filterOptionList"
          :key="index"
          class="option"
          :class="isFilterOptionActive( index ) ? [ 'active' ] : []"
          @click="selectFilterOption( index )">
          {{ item }}
        </div>
      </div>
      <div class="buttonBlock">
        <div class="cancel" @click="cancel">
          取消
        </div>
        <div class="submit" @click="submit">
          确定
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  const filterCodeList = [ 'flight', 'train', 'other' ];

  const sortModeList = [
    'publishTimeDescend', 'publishTimeAscend', 'dateDescend', 'dateAscend'
  ];

  export default {
    data() {
      return {
        sortOptionList : [
          '发布日期由晚到早', '发布日期由早到晚', '行程日期由晚到早', '行程日期由早到晚'
        ],

        filterOptionList  : [ '显示飞机行程', '显示火车行程', '显示市内交通及地点' ],
        currentSortMode   : 'publishTimeDescend',
        currentFilterList : [ 'flight', 'train', 'other' ]
      };
    },

    computed : {
      ...mapState( 'virusTrip', [
        'showMenuWindow', 'sortMode', 'filterList', 'searchType'
      ] ),

      showFilter() {
        return this.searchType !== 'train' && this.searchType !== 'flight';
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [
        'updateShowMenuWindow', 'updateSortMode', 'updateFilterList'
      ] ),

      isSortOptionActive( index ) {
        let sortOptionIndex;

        sortOptionIndex = sortModeList.indexOf( this.currentSortMode );

        return index === sortOptionIndex;
      },

      selectSortOption( index ) {
        this.currentSortMode = sortModeList[ index ];
      },

      isFilterOptionActive( index ) {
        const filterOption = filterCodeList[ index ];

        return this.currentFilterList.indexOf( filterOption ) >= 0;
      },

      selectFilterOption( index ) {
        let filterList;

        filterList = [ ...this.currentFilterList ];

        const filterOption = filterCodeList[ index ];

        if ( filterList.indexOf( filterOption ) >= 0 ) {
          if ( filterList.length > 1 ) {
            filterList = filterList.filter( ( item ) => {
              return item !== filterOption;
            } );
          }
        } else {
          filterList.push( filterOption );
        }

        this.currentFilterList = filterList;
      },

      cancel() {
        this.currentSortMode = this.sortMode;
        this.currentFilterList = this.filterList;

        this.updateShowMenuWindow( false );
      },

      submit() {
        this.updateSortMode( this.currentSortMode );
        this.updateFilterList( this.currentFilterList );
        this.updateShowMenuWindow( false );
        window.scrollTo( 0, 0 );
      }
    },

    watch : {
      sortMode : function( newValue ) {
        this.currentSortMode = newValue;
      },

      filterList : function( newValue ) {
        this.currentFilterList = newValue;
      }
    },

    mounted() {
      this.currentSortMode   = this.sortMode;
      this.currentFilterList = this.filterList;
    }
  };
</script>

<style scoped lang="scss">
  @import "./menu-window.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/menu-window.vue